import { Component, OnInit } from '@angular/core';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { ActivatedRoute } from '@angular/router';
import { HtmlMetaManagerService } from '../../../app/services/html-meta-manager.service';
import translations from '../../../../assets/i18n/en';
import { appSetting } from "../../../../config/appSettings";
import { AuthService } from 'modules/app/services/auth.service';

@Component({
    selector: 'attempts-exceeded',
    templateUrl: './attempts-exceeded.template.html',
    styleUrls: ['./attempts-exceeded.style.scss'],
    standalone: false
})

export class AttemptsExceeded implements OnInit {

    attemptLimit: any;
    attemptLimitNumber: number;
    isAttNoWithinTransformLimit: boolean = false;
    language: string;
    public userData: any = {};
    
    public pluralMapping;

    constructor(
        private route: ActivatedRoute,
        private appHelperService: AppHelperService,
        private htmlMetaManagerService: HtmlMetaManagerService,
        private authService : AuthService
    ) {
        this.pluralMapping = this.appHelperService.pluralMapping;
     }
    ngOnInit() {
        this.userData = this.authService.getUserData() || {};
        this.htmlMetaManagerService.setTitle(translations.HTML_META.WARNING_MESSAGE.TITLE)
        this.attemptLimitNumber = this.route.snapshot.params.attemptLimit && Number(this.route.snapshot.params.attemptLimit);
        this.language = localStorage.getItem(appSetting.localStorage.lang);
        this.isAttNoWithinTransformLimit = this.attemptLimitNumber > 0 && this.attemptLimitNumber <= 100;
        this.attemptLimit = this.attemptLimitNumber;
        if(this.isAttNoWithinTransformLimit && this.language === "en") {
            this.attemptLimit = this.numberToWords(this.attemptLimitNumber);
        }
    }
    navigateToDashboard() {
        this.appHelperService.navigateToDashboardApp([]);
    }

    numberToWords(value): string {
        let a = [
            '',
            'one',
            'two',
            'three',
            'four',
            'five',
            'six',
            'seven',
            'eight',
            'nine',
            'ten',
            'eleven',
            'twelve',
            'thirteen',
            'fourteen',
            'fifteen',
            'sixteen',
            'seventeen',
            'eighteen',
            'nineteen'];

        let b = [
            '',
            '',
            'twenty',
            'thirty',
            'forty',
            'fifty',
            'sixty',
            'seventy',
            'eighty',
            'ninety'];

        if (value) {
            if (value > 100) {
                return '';
            }
            const num = ('000' + value).substr(-3).match(/^(\d{1})(\d{2})$/);
            let str = '';
            str += (Number(num[1]) !== 0) ? a[num[1]] + ' ' + 'hundred' : '';
            str += (Number(num[2]) !== 0) ? a[Number(num[2])] || b[num[2][0]] + ((a[num[2][1]] !== '') ? ' ' : '') + a[num[2][1]] : '';
            return str;
        } else {
            return '';
        }
    }

}
